import React, { useEffect, useState } from 'react'
import { Slide } from './slideService.js'
import './SlideshowPreview.scss'

const SlideshowPreview = ({ colorTheme, slides = [] }) => {
    const [firstSlide, setFirstSlide] = useState(() => {
        if (Array.isArray(slides)) {
            return slides[0]
        }
        return new Slide({})
    })

    useEffect(() => {
        if (Array.isArray(slides)) {
            setFirstSlide(slides[0])
        }
    }, [slides])

    return (
        <div className="slideshow__container">
            <div className="slideshow__container-thumbnails">
                <div className="slideshow__container-thumbnails-items">
                    {slides.map((slide, index) => (
                        <div
                            key={`thumbnails-img-${index}`}
                            className={`slideshow__container-thumbnails-items-img ${
                                firstSlide.id === slide.id ? 'selected' : ''
                            }`}
                            style={{
                                backgroundImage: `url(${slide.image.replace('/NORMAL', '/SMALL')})`,
                                backgroundColor: { colorTheme },
                            }}
                        />
                    ))}
                </div>
            </div>
            <div className="slideshow__container-carousel">
                <div className="slideshow__container-carousel-items">
                    <div
                        className="slideshow__container-carousel-items-img"
                        style={{
                            backgroundImage: `url(${firstSlide.image})`,
                        }}
                    />
                </div>
            </div>
            <div className="slideshow__container-descriptions">
                {firstSlide.hasTextOptions && firstSlide.header ? (
                    <div className="slideshow__container-descriptions-header">{firstSlide.header}</div>
                ) : null}
                {firstSlide.description ? (
                    <div className="slideshow__container-descriptions-text">{firstSlide.description}</div>
                ) : null}
                {firstSlide.hasTextOptions && firstSlide.imageCaption ? (
                    <div className="slideshow__container-descriptions-image-caption">{firstSlide.imageCaption}</div>
                ) : null}
            </div>
        </div>
    )
}

export default SlideshowPreview
